module.exports = __webpack_public_path__ + "static/logo-253c09ac8802e567709c4642e4015a2e.png";